// extracted by mini-css-extract-plugin
export default {"title":"title__3ANVg","text":"text__GvLXO","fieldWrapper":"fieldWrapper__2Hd16","cta":"cta__1UBBW","errorWrapper":"errorWrapper__17Z4E"};